

































import { PermissionGroupParams } from '@/store/interfaces/PermissionGroup';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'ViewPermissionModal',
  props: {
    viewModal: {
      type: Boolean,
      required: true,
    },
    groupInfo: {
      type: Object as PropType<PermissionGroupParams>,
      required: true,
    },
  },
  computed: {
    syncedViewModal: {
      get(): boolean {
        return this.viewModal;
      },
      set(value: boolean) {
        this.$emit('update:viewModal', value);
      },
    },
  },
});
